import React from "react";
import "../../index.scss";
import "../../_metronic/_assets/plugins/keenthemes-icons/font/ki.css";
import "socicon/css/socicon.css";
import "react-redux-toastr/lib/css/react-redux-toastr.min.css";
import "@fortawesome/fontawesome-free/css/all.min.css";
import "../../_metronic/_assets/plugins/flaticon/flaticon.css";
import "../../_metronic/_assets/plugins/flaticon2/flaticon.css";
import "react-datepicker/dist/react-datepicker.css";

const PublicPageStyles = () => <React.Fragment></React.Fragment>;

export default PublicPageStyles;
